// import { drilldownDataCorporate, ModuleFields } from "~/Utils/drilldownDataDum";

// const mapFields = (data: ModuleFields[]) => {
//   return data.map(({ fieldName, placeholder, name, formType, validation, className, hidden, dynamicFormType, rowConfig }) => {
//     return {
//       name,
//       type: formType,
//       label: fieldName,
//       placeholder,
//       validation,
//       className,
//       hidden,
//       dynamicFormType,
      // rowConfig: rowConfig
      //   ? {
      //       ...rowConfig,
      //       fields: rowConfig.fields.map((field: any) => ({
      //         name: field.name,
      //         type: field.formType,
      //         label: field.fieldName,
      //         placeholder: field.placeholder,
      //         validation: field.validation,
      //         className: field.className,
      //         hidden: field.hidden,
      //         usedFileType: field.usedFileType,
      //         note: field.note,
      //       })),
      //     }
      //   : undefined,
//     };
//   });
// };


// let fields: any = {};

// const fieldsReady = async (id?: string | number) => {
//   try {
//     const data = await drilldownDataCorporate(id);
//     console.log("constantdatadum", data);

//     fields = {
      // introduction: mapFields(data?.introduction || []),
      // trainingFacilities: mapFields(data?.trainingFacilities || []),
      // accreditationAndCertifications: mapFields(data?.accreditationAndCertifications || []),
      // milestones: mapFields(data?.milestones || [])
//     };

//     console.log("constantsdum", fields);
//     return fields; 
//   } catch (error) {
//     console.error("Error accessing drilldown data:", error);
//     throw error;
//   }
// };

// export { fields, fieldsReady };


import { drilldownDataCorporate, ModuleFields } from "~/Utils/drilldownDataDum";

const mapFields = (data: ModuleFields[]) => {
  console.log("mapFieldssssssss", data);
  return data.map(({ fieldName, placeholder, name, formType, validation, className, hidden, dynamicFormType, rowConfig, usedFileType, disabledPreviousDateTime }) => {
    return {
      name,
      type: formType,
      label: fieldName,
      placeholder,
      validation,
      className,
      hidden,
      usedFileType,
      disabledPreviousDateTime,
      dynamicFormType,
      rowConfig: rowConfig 
        ? rowConfig.map((row: any) => ({
            fields: row.fields.map((field: any) => ({
              name: field.name,
              type: field.formType,
              label: field.fieldName,
              placeholder: field.placeholder,
              validation: field.validation,
              className: field.className,
              hidden: field.hidden,
              usedFileType: field.usedFileType,
              note: field.note,
              fieldValue: field.fieldValue,
            }))
          }))
        : undefined
    };
  });
};


let fields: any = {};

const fieldsReady = async (id?: any) => {

  return new Promise(async (resolve, reject) => {
    try {
      const data = await drilldownDataCorporate(id);
      console.log("datasssssssssssssss", data);
      fields = {
        introduction: mapFields(data?.introduction || []),
        trainingFacilities: mapFields(data?.trainingFacilities || []),
        accreditationAndCertifications: mapFields(data?.accreditationAndCertifications || []),
        milestones: mapFields(data?.milestones || []),
        latestNews: mapFields(data?.latestNews || []),
        latestNewsList: mapFields(data?.latestNewsList || []),
        ourClients: mapFields(data?.ourClients || []),
        trainingAcademyBanner: mapFields(data?.trainingAcademyBanner || []),
        videoSection: mapFields(data?.videoSection || []) 
      };
      resolve(fields);
    } catch (error) {
      console.error("Error accessing drilldown data:", error);
      reject(error);
    }
  });
};

export { fields, fieldsReady };